export default "__VITE_ASSET__C1yh4Ncx__"